<ng-content select="kb-footer-link" /> <!-- https://github.com/angular/angular/issues/50543 -->

<h3 kb-heading>{{heading}}</h3>
<ul>
  @for (link of leftLinks(); track link.href) {
    <li>
      <a kb-link [kbRouterOrExternalLink]="link.href" [attr.target]="link.target">
        <ng-container *ngTemplateOutlet="link.content()" />
      </a>
    </li>
  }
</ul>
